import { render, staticRenderFns } from "./RacerAdjustments.vue?vue&type=template&id=04869dda"
import script from "./RacerAdjustments.vue?vue&type=script&lang=js"
export * from "./RacerAdjustments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports